import { useEffect } from 'react';

import { useRouter } from 'next/router';
import { useCachedBasketData } from '@JohnLewisPartnership/jl-design-system/utils/basket/cachedBasket';
import { setJLData } from './setJLData';
import { getAnalyticsData } from './utils/transformations';

import { useFacetContext } from '../../context/FacetContext';
import { useBreadcrumbContext } from '../../context/BreadcrumbContext';
import { useCompareContext } from '../../context/CompareContext';
import { useSearchContext } from '../../context/SearchContext';
import { useProductContext } from '../../context/ProductContext';

import { createDebugger } from '../debug/Debug';
import { useAnalyticsContext } from '../../context/AnalyticsContext';

const debug = createDebugger('analytics');
import { ANALYTICS_JLDATA_UPDATED } from './events';
import { useAnalyticsCompareUpdate } from './update-hooks/useAnalyticsCompareUpdate';
import { useAnalyticsProductUpdate } from './update-hooks/useAnalyticsProductUpdate';
import { useAnalyticsProductCardViewUpdate } from './update-hooks/useAnalyticsProductCardViewUpdate';

export const Analytics = ({ page }) => {
  const [, updateTimestamp] = useAnalyticsContext();

  const compare = useCompareContext();
  const search = useSearchContext();
  const { breadcrumbs } = useBreadcrumbContext();
  const facets = useFacetContext();
  const productData = useProductContext();
  const { query } = useRouter();
  const { chunk = '1' } = query;

  const serialiseDependencies = (value) => JSON.stringify(value);

  const compareUpdates = useAnalyticsCompareUpdate();
  const productUpdates = useAnalyticsProductUpdate();
  const productCardViewUpdates = useAnalyticsProductCardViewUpdate();
  const basketUpdates = useCachedBasketData();

  const dependencies = [
    serialiseDependencies(compareUpdates),
    serialiseDependencies(productUpdates),
    serialiseDependencies(productCardViewUpdates),
    serialiseDependencies(basketUpdates),
  ];

  useEffect(() => {
    const analytics = getAnalyticsData({
      compare,
      facets,
      page,
      productData,
      search,
      chunk,
    });
    setJLData(breadcrumbs, analytics, search, page);
    updateTimestamp();
    debug(`dispatching event "${ANALYTICS_JLDATA_UPDATED}"`);
    document.body.dispatchEvent(new CustomEvent(ANALYTICS_JLDATA_UPDATED));
    // // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return null;
};
